@import (reference) '../../../../../../../../constants/spacing.module.less';

.setting-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: @space-16;
  margin-bottom: @space-24;
  border-bottom: 1px solid var(--grey-300);

  &:last-child {
    padding-bottom: @space-0;
    margin-bottom: @space-0;
    border-bottom: none;
  }
}

.setting-text {
  flex: 1;
  margin-right: @space-16;
}
